import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { CajuMUItheme } from "./configs/mui/theming";
import { FeatureFlagProvider } from "services/featureFlag";
import { logger, metrics } from "@caju-beneficios/monitoring";
import "./assets/styles/font.css";

// Initialize DataDog monitoring logger
logger.init({
  environment: (
    process.env.REACT_APP_ENVIRONMENT || "development"
  ).toLowerCase(),
  datadog: {
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN || "",
    service: "quero-caju",
    site: "datadoghq.com",
    env: (process.env.REACT_APP_ENVIRONMENT || "development").toLowerCase(),
    forwardErrorsToLogs: false,
  },
});

// Initialize DataDog monitoring metrics
metrics.init({
  environment: (
    process.env.REACT_APP_ENVIRONMENT || "development"
  ).toLowerCase(),
  config: {
    applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID || "",
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN || "",
    service: "quero-caju",
    site: "datadoghq.com",
    env: (process.env.REACT_APP_ENVIRONMENT || "development").toLowerCase(),
    sessionSampleRate: 50,
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <FeatureFlagProvider>
    <ThemeProvider theme={CajuMUItheme}>
      <CssBaseline />
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ThemeProvider>
  </FeatureFlagProvider>,
);
